export default __webpack_public_path__ + "static/media/tax-report.0fe0a7d5.png";